module.exports = __webpack_public_path__ + "img/img33.568e1faf.png";